import { FC, memo } from 'react'
// import { Box } from '@chakra-ui/react'
import { createIcon } from '@chakra-ui/icons'

import { CustomIconProps } from 'types'
import CustomIcon from '../../CustomIcon'

const FolderPenOutline = createIcon({
  displayName: 'FolderPenOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M17,20h2a1.99945,1.99945,0,0,0,2-2V8.94a2.00009,2.00009,0,0,0-2-2H12.529a.99981.99981,0,0,1-.827-.438L10.297,4.437A.99961.99961,0,0,0,9.471,4H5A1.99945,1.99945,0,0,0,3,6V16"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="6"
        y1="20"
        x2="3"
        y2="20"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M11.66572,19.70708l3.11465-3.11481a.74994.74994,0,0,0,0-1.06057l-1.312-1.312a.75.75,0,0,0-1.06064,0L9.29291,17.33431A1,1,0,0,0,9,18.04142V19.75a.25.25,0,0,0,.25.25h1.70858A1,1,0,0,0,11.66572,19.70708Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path d="M0,0H24V24H0Z" fill="none" />
    </>
  ),
})

const FolderPen: FC<CustomIconProps> = (props) => {
  // if (props.variant === 'twoTone') return <CustomIcon as={FolderPenTwoTone} {...props} />

  return <CustomIcon as={FolderPenOutline} {...props} />
}

export default memo(FolderPen)
